import React from 'react';
import {
    HTMLDialog,
    Icon,
    PriorityIcon,
    Title,
    Text,
    Flex,
    Button
} from '@priority-software/priority-style-react';
import texts from '../texts';
import styles from '../EmailVerification.module.scss';

interface FooterProps {
    onCancel: () => void;
    onConfirm: () => void;
}

interface Props extends FooterProps {
    isOpen: boolean;
}

const Footer = ({onCancel, onConfirm}: FooterProps) => {
    return (
        <Flex justifyContent="flex-end" componentClasses={styles.messageFooter}>
            <Button size="medium" wideButton skin="secondary" onClick={onCancel}>
                {texts.cancelBtn}
            </Button>
            <Button size="medium" wideButton autoFocus onClick={onConfirm}>
                {texts.confirmBtn}
            </Button>
        </Flex>
    );
};

export const EmailChangedConfirmation = ({isOpen, onCancel, onConfirm}: Props) => {
    return (
        <HTMLDialog
            isOpen={isOpen}
            componentClasses={styles.messageComponent}
            toolbarContent={
                <Icon
                    icon={PriorityIcon.attention}
                    iconColor="secondary-500"
                    componentClasses={styles.toolbarIcon}
                />
            }
            title={<Title skin="h4" text={texts.messageTitle} />}
            content={<Text skin="paragraph-2">{texts.confirmEmailChange} </Text>}
            footer={<Footer onCancel={onCancel} onConfirm={onConfirm} />}
            onClose={onCancel}
        />
    );
};
